<div class="budget-settings-dates-range">
  <ng-container *ngIf="startDate && endDate">
    {{ startDate | date: budgetDateFormat }} - {{ endDate | date: budgetDateFormat }}
  </ng-container>
</div>
